import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private _isOpenMenu$ = new BehaviorSubject<boolean>(false);

  get isOpenMenu$(): Observable<boolean> {
    return this._isOpenMenu$.asObservable();
  }

  setMenuState(state: boolean) {
    this._isOpenMenu$.next(state);
  }

  // Kept here rather than in the switcher itself so the list stays expanded
  // across project switches even if the sidebar gets re-created on the way.
  private _isProjectSwitcherOpen$ = new BehaviorSubject<boolean>(false);

  get isProjectSwitcherOpen$(): Observable<boolean> {
    return this._isProjectSwitcherOpen$.asObservable();
  }

  setProjectSwitcherOpen(state: boolean) {
    this._isProjectSwitcherOpen$.next(state);
  }
}
